import { action, observable, makeObservable } from 'mobx';
import {ModalMessage, ModalPrompt} from './modal-message';

function noop() {
}

interface PromptOptions {
  message: string;
  confirmLabel?: string;
  confirmAction?: (() => void);
  cancelLabel?: string;
  cancelAction?: (() => void);
}

function prompt(options: PromptOptions): ModalPrompt {
  if (options.confirmLabel === undefined)
    options.confirmLabel = 'Ok';
  if (options.confirmAction === undefined)
    options.confirmAction = noop;
  if (options.cancelLabel === undefined)
    options.cancelLabel = 'Cancel';
  if (options.cancelAction === undefined)
    options.cancelAction = noop;

  return {
    modalType: 'prompt',
    message: options.message,
    confirmLabel: options.confirmLabel,
    confirmAction: options.confirmAction,
    cancelLabel: options.cancelLabel,
    cancelAction: options.cancelAction
  };
}

class ModalMessageService {
  @observable.ref
  message: ModalMessage | null;

  constructor() {
    makeObservable(this);
    this.message = null;
  }

  @action
  prompt = (options: PromptOptions) => {
    this.message = prompt(options);
  };

  @action
  clear = () => {
    this.message = null;
  };
}

export const modalMessageService = new ModalMessageService();
